import React, {Component} from 'react';
import { Modal,Menu,SearchBar} from 'antd-mobile';
import { tools} from 'tplus-voucher';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import './index.less';

@observer
export default class SearchRemote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showList: false,
      value:''
    }
    this.SearchBar = React.createRef()
  }

  componentDidMount() {
    // 点击除搜索按钮的其他地方隐藏下拉框
    document.addEventListener('click', (e) => {
      if(e.target.className === 'searchBtn')return
      if(this.state.showList){
        this.setState({
          showList : false
        })
      }
    })
}
  searchChange = (value) => {
    this.setState({
      value: value
    })
  }

  handleChange = () => {
    if(this.state.value){
      this.props.onChange(this.state.value)
      //解决因为上次有数据，这次没数据造成的下拉框闪现问题，改为异步
      setTimeout(() => {
        this.changeShowList(true)
      },100)
    }
  }

  //清空搜索框
  searchClear = () => {
    this.setState({
      value: ''
    })
    this.changeShowList(false);
  }

  //item选择时触发
  itemClick = (obj) => {
    //更新searchBar的value
    //this.SearchBar.current.value = obj.invopt
    this.searchChange(obj.invopt)
    this.changeShowList(false)
    this.selectItemChange(obj)
  }

  //选择下拉选项时，获取所选值的详情信息
  selectItemChange = (obj) => {
    this.props.onSelectChange(obj)
  }

  //改变下拉框的现实状态
  changeShowList = (value) => {
    this.setState({
      showList : value
    })
  }

  render() {
    const {placeholder,list,value} = this.props;
    let items = []
    list.forEach((e,index) => {
      items.push(<li key={index} onClick={this.itemClick.bind(this,e)}>{e.invopt}</li>)
    });
    return(
      <div className="SearchRemote">
        <div className="SearchDropList">
          <SearchBar
            ref = {this.SearchBar}
            value = {this.state.value}
            placeholder={placeholder} 
            onClear = {this.searchClear}
            onChange= {this.searchChange}>
          </SearchBar>
          <button className="searchBtn" onClick={this.handleChange}>搜索</button>
        </div>
        <ul className = "DropDownList" className={ this.state.showList ? 'showList' : 'hideList'}>
          {items}
        </ul>
      </div>
    )
  }
}
